import { Injectable } from "@angular/core";
import {
  PRIMITIVE,
  ServiceMessageBrokerFactory,
  ServiceMessageBroker,
} from "shared/provider-webworker";

import { RateSourceLookupService } from "./RateSourceLookupService";
import { PrimaryLookupService } from "../../impl/PrimaryLookupService";
import { IRateSourcePromiseLookupService } from "../IRateSourcePromiseLookupService";
import { BaseLookupService } from "../../impl/BaseLookupService";
import { PromiseLookupService } from "../../impl/PromiseLookupService";

import { CubiqWorker } from "../../../worker/CubiqWorker";

import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

@Injectable()
export class RateSourcePrimaryLookupService
  extends PrimaryLookupService<string, CubiqTS.RateSourceImpl>
  implements IRateSourcePromiseLookupService
{
  constructor(
    protected base: RateSourceLookupService,
    protected factory: ServiceMessageBrokerFactory,
    protected cubiqWorker: CubiqWorker,
  ) {
    super(base, factory, CubiqTS.RateSourceImpl, cubiqWorker, "RateSourceImpl");

    cubiqWorker.isAuth(`${this.constructor.name}`).then(
      () => {
        let rateSourceObservable = cubiqWorker.primeStaticData<CubiqTS.RateSourceImpl>(
          CubiqTS.RateSourceImpl.name,
        );

        rateSourceObservable.subscribe(
          (rateSource: CubiqTS.RateSourceImpl[]) => {
            this.base.prime(rateSource);
          },
          (error: Error) => {
            console.debug("RateSource prime failed");
            this._primed.reject(error);
          },
          () => {
            this._primed.resolve(true);
          },
        );
      },
      (reason) => {
        console.debug("RateSourcePrimaryLookupService: Failed to prime: " + reason);

        this._primed.resolve(false);
      },
    );

    this.broker.registerMethod(
      "getRateSource",
      [PRIMITIVE],
      this.getRateSource.bind(this),
      this.VALUE,
    );
  }

  // Does not work since Long encoded as primitive, use getTraderGroupForSid()
  getRateSource(id: string): Promise<CubiqTS.RateSourceImpl> {
    return new Promise<CubiqTS.RateSourceImpl>((res, rej) => {
      res(this.base.getRateSource(id));
    });
  }
}
